// extracted by mini-css-extract-plugin
export default {"setupTitle":"SetupState_setupTitle__7YsXA","main":"SetupState_main__VZlOX","content":"SetupState_content__0Qr69"};